const guiColors = {
    'motion-primary': 'hsla(215, 100%, 65%, 1)',
    'motion-primary-transparent': 'hsla(215, 100%, 65%, 0.9)',
    'motion-tertiary': 'hsla(215, 60%, 50%, 1)',

    'looks-secondary': 'hsla(215, 100%, 65%, 1)',
    'looks-transparent': 'hsla(215, 100%, 65%, 0.35)',
    'looks-light-transparent': 'hsla(215, 100%, 65%, 0.15)',
    'looks-secondary-dark': 'hsla(215, 60%, 50%, 1)',

    'extensions-primary': 'hsla(225, 85%, 65%, 1)',
    'extensions-tertiary': 'hsla(225, 85%, 40%, 1)',
    'extensions-transparent': 'hsla(225, 85%, 65%, 0.35)',
    'extensions-light': 'hsla(225, 57%, 85%, 1)',

    'drop-highlight': 'hsl(215, 100%, 78%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(215, 100%, 65%)',
    checkboxActiveBorder: 'hsl(215, 60%, 50%)'
};

export {
    guiColors,
    blockColors
};